<template>
<div>
  <header class="main-header home-page">
    <div class="center">
      <a href="index.html" class="main-logo">
        <img src="../Content/images/logo.png" alt="Primavida Dental">
      </a>
      <!-- <i class="fas fa-bars open-menu"></i> -->
      <ul class="main-nav">
        <li>
          <router-link to="/" class='active'>Comercial</router-link>
        </li>
        <li>
          <a href="https://www.primavida.com.br">Home</a>
        </li>
        <li>
          <a href="https://www.primavida.com.br/redecredenciada">Rede Credenciada</a>
        </li>
       <!-- <li>
          Planos Odontológicos <i class="fas fa-angle-down"></i>
          <div class="submenu">
            <router-link :to="{ path: '/pessoafisica' }">Pessoa Física</router-link>-->
            <!-- <a @click.prevent="exibeMsgConstrucao()" >Servidor Público</a>  -->
            <!-- <a @click="exibeMsgConstrucao()">Pessoa Jurídica</a> -->
           <!-- <router-link :to="{ path: '/servidorpublico' }">Servidor Público</router-link>
            <router-link :to="{ path: '/pessoajuridica' }">Pessoa Jurídica</router-link>
          </div>
        </li>-->
        <li>
          <router-link to="/contato">Contato</router-link>
        </li>
        <li>
          <router-link to="/areacliente">Área do Cliente</router-link>
        </li>
        <li>
          <router-link to="/faq">FAQ</router-link>
        </li>
        <li>
          Área de Acesso <i class="fas fa-angle-down"></i>
          <div class="submenu">
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=100">Colaborador C.</a>
            <a href="https://primavida.s4e.com.br/SYS/" >Administrativo</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=1" >Beneficiário</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=2" >Empresa</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=10">Corretor</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=3-4">Dentista</a>
            <a href="https://webmail.primavida.com.br/">Webmail</a>
          </div>
        </li>
        <li v-if="userloggedin">
          <a @click="Sair">Sair</a>
        </li>
      </ul>
    </div>
  </header>

  <section class="main-banner">
    <div class="center">
      <div class="texto">
        <p class="title" >Venha<br><span class="title">para o plano que</span><br>mais cresce no Brasil</p>
        <p>O plano odontológico PrimaVida cuida da sua saúde bucal com qualidade, flexibilidade de valores e uma grande rede de atendimento.</p>
      </div>
      <div class="planos">
        <p class="label">Confira nossos planos</p>
        <a planojuridico href="https://www.primavida.com.br/prefeiturasp">Planos <strong>Prefeitura São Paulo</strong><i class="fas fa-angle-right"></i></a>
        <a planojuridico href="https://www.primavida.com.br/adesaopessoafisica">Planos para <strong>Pessoa Física</strong><i class="fas fa-angle-right"></i></a>
        <!--<router-link :to="{ path: '/pessoafisica' }">Planos para <strong>Pessoa Física</strong><i class="fas fa-angle-right"></i></router-link>-->
        <!-- <a @click.prevent="exibeMsgConstrucao()" >Planos para <strong>Servidor Público</strong><i class="fas fa-angle-right"></i></a> -->
        <!-- <a planojuridico @click="exibeMsgConstrucao()">Planos para <strong>Pessoa Jurídica</strong><i class="fas fa-angle-right"></i></a> -->
        <a planojuridico href="https://www.primavida.com.br/servidorpublico">Planos para <strong>Servidor Público</strong><i class="fas fa-angle-right"></i></a>
        <!--<router-link :to="{ path: '/servidorpublico' }">Planos para <strong>Servidor Público</strong><i class="fas fa-angle-right"></i></router-link>-->
        <router-link :to="{ path: '/pessoajuridica' }">Planos para <strong>Pessoa Jurídica</strong><i class="fas fa-angle-right"></i></router-link>

      </div>
    </div>
  </section>

  <section class="home-wrapper">
    <div class="center">
      <p class="area-title"><strong>Principais coberturas </strong>dos planos</p>
      <div class="cobertura-list">
        <div class="item">
          <p class="titleItens">Consulta</p>
          <p>Consultas iniciais para avaliação do plano de tratamento.</p>
        </div>
        <div class="item teal lighten-1">
          <p class="titleItens">Urgência</p>
          <p>Diversos procedimentos de urgência odontológica.</p>
        </div>
        <div class="item">
          <p class="titleItens">Cirurgia</p>
          <p>Cirurgias odontológicas de pequeno porte realizada em consultórios.</p>
        </div>
        <div class="item teal lighten-1">
          <p class="titleItens">Dentística</p>
          <p>Restaurações e obturações em material estético (resina) e amálgama.</p>
        </div>
        <div class="item teal lighten-1">
          <p class="titleItens">Endodontia</p>
          <p>Tratamento de canais.</p>
        </div>
        <div class="item">
          <p class="titleItens">Periodontia</p>
          <p>Tratamento de gengivas.</p>
        </div>
        <div class="item teal lighten-1">
          <p class="titleItens">Odontopediatria</p>
          <p>Atendimento especializado para crianças.</p>
        </div>
        <div class="item">
          <p class="titleItens">Radiologia</p>
          <p>Radiografias intra-orais e radiografias panorâmicas.</p>
        </div>
        <div class="item">
          <p class="titleItens">Prevenção</p>
          <p>Profilaxia / Aplicação de flúor</p>
        </div>
        <div class="item bigger teal lighten-1">
          <p class="titleItens">Prótese</p>
          <p>Coroas provisórias, blocos e coroas metálicas para dentes posteriores, e em cerômero para dentes permanentes anteriores (dentes definitivos da frente que correspondem do canino esquerdo ao canino direito)</p>
        </div>
        <div class="item">
          <p class="titleItens">Exodontia</p>
          <p>Extração, inclusive de siso incluso.</p>
        </div>
      </div>
      <p class="area-title">Ainda possui alguma dúvida?</p>
      <router-link to="/contato" class="button-contact"><i class="far fa-comment-alt"></i>Entre em contato</router-link>
    </div>
  </section>
  <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import {
  mapState
} from 'vuex'
export default {
  components: {
    Snackbar
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      userloggedin: state => state.userloggedin,
      escondetoolbar: state => state.isToolbarVisible
    })
  },
  mounted: function () {
    this.$store.dispatch('EscondeToolbar')
    this.$store.dispatch('ExibeToolbarCell')
    this.$store.dispatch('Logar')
  },
  methods: {
    Sair() {
      this.$store.dispatch('Sair')
    },
    exibeMsgConstrucao() {
      var vm = this;
      vm.$refs.chamaSnackbar.snack("#0288D1", "Disponível em breve!", "INFORMAÇÃO")
    }
  }
}
</script>

<style>
.main-header.page-intern {
  position: fixed !important;
}

.title {
  font-size: 45px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
}

.title2 {
  font-size: 45px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
}


.titleItens {
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
  margin-bottom: 10px;
  font-size: 26px;
  line-height: 26px;
  margin-bottom: 10px;
}
</style>
